import { useContext, useEffect, useState } from 'react';
import Axios from 'axios';
import DashboardContext from 'Context';
import toaster from 'helper/toaster';
import { Button, Col, Modal, Row, Space, Table, Tag } from 'antd';

/**
 * این کامپوننت برای نمایش مدال پیگیری در جدول سفارشات است
 */
const ServicePointGroups = ({ openModal, close, id, orderScheduleId }) => {
  const { urldashboard, authentication, handelerrors } =
    useContext(DashboardContext);

  const [submitLoading, setSubmitLoading] = useState(false);
  const [workersLoading, setWorkersLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [workerModal, setWorkerModal] = useState(false);
  const [data, setData] = useState([]);
  const [workers, setWorkers] = useState([]);
  const [line, setLine] = useState(null);
  const [rowId, setRowId] = useState(null);

  useEffect(() => {
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getList = async () => {
    setLoading(true);
    try {
      let url = `/groupOrderScheduleAddressServicePoint/get?orderScheduleAddressServicePointId=${id}`;
      const res = await Axios.get(urldashboard + url, {
        headers: {
          Authorization: authentication,
          'Content-Type': 'application/json',
        },
      });
      const data = await res.data;
      const items = data?.data?.map((obj) => ({ ...obj, key: obj.id }));
      setData(items);
      setLoading(false);
    } catch (error) {
      setData([]);
      setLoading(false);
    }
  };

  const handleDelete = async (recordId) => {
    try {
      const res = await Axios.delete(
        `${urldashboard}/groupOrderScheduleAddressServicePoint/delete?groupOrderScheduleAddressServicePointId=${recordId}`,
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
          data: {},
        }
      );
      const data = res?.data;
      toaster.success(data.message);
      getList();
    } catch (error) {
      handelerrors(error);
    }
  };

  const columns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg'],
      render: (_, record, index) => <>{index + 1}</>,
    },
    {
      title: 'ظرفیت',
      dataIndex: 'capacity',
      key: 'capacity',
      responsive: ['xl', 'lg', 'md'],
      render: (value, record) => (
        <span
          style={{ color: record?.isCompleteCapacity ? 'green' : 'orange' }}
        >
          {record?.workers?.length}/{value}
        </span>
      ),
    },
    {
      title: 'مسیر',
      dataIndex: 'transportationLineType',
      key: 'transportationLineType',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ? 'برگشت' : 'رفت'}</span>,
    },
    {
      title: 'وضعیت سفر',
      dataIndex: 'transportationTripStatusTypeTitle',
      key: 'transportationTripStatusTypeTitle',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'نیروها',
      dataIndex: 'workers',
      key: 'workers',
      responsive: ['xl', 'lg'],
      render: (values) => (
        <Space>
          {values?.map((item) => (
            <Tag color={item?.isLeader ? '#d4af37' : '#7c7c7c'}>
              {item?.fullName}
            </Tag>
          ))}
        </Space>
      ),
    },
    {
      title: 'عملیات',
      dataIndex: 'groupOrderScheduleAddressServicePointId',
      key: 'groupOrderScheduleAddressServicePointId',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value, record) => (
        <Space>
          <Button
            type={'primary'}
            onClick={() =>
              handleEdit(
                value,
                record?.workers,
                record?.transportationLineType
              )
            }
          >
            تخصیص نیروها
          </Button>
          <Button danger type={'primary'} onClick={() => handleDelete(value)}>
            حذف
          </Button>
        </Space>
      ),
    },
  ];

  const handleEdit = async (groupId, workers, lineType) => {
    setSelectedRowKeys(workers?.map((item) => item?.workerOrderScheduleId));
    setLine(lineType);
    setWorkerModal(true);
    setWorkersLoading(true);
    setRowId(groupId);
    try {
      const res = await Axios.post(
        `${urldashboard}/workerOrderSchedule/get`,
        JSON.stringify({ page: 1, pageSize: 50, orderScheduleId }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      const data = await res.data;
      const items = data?.data?.map((obj) => ({ ...obj, key: obj.id }));
      setWorkers(items);
      setWorkersLoading(false);
    } catch (error) {
      handelerrors(error);
      setWorkersLoading(false);
    }
  };

  const workerColumns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg'],
      render: (_, record, index) => <>{index + 1}</>,
    },
    {
      title: 'نام نیرو',
      dataIndex: 'workerFullName',
      key: 'workerFullName',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'شماره موبایل',
      dataIndex: 'workerPhoneNo',
      key: 'workerPhoneNo',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
  ];

  const handleSubmit = async () => {
    setSubmitLoading(true);
    try {
      const res = await Axios.post(
        `${urldashboard}/groupOrderScheduleAddressServicePoint/setWorker`,
        JSON.stringify({
          groupOrderScheduleAddressServicePointId: rowId,
          transportationLineType: line,
          groupWorkers: selectedRowKeys?.map((item) => {
            return {
              workerOrderScheduleId: item,
              isLeader: false,
            };
          }),
        }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      setSubmitLoading(false);
      const data = res?.data;
      toaster.success(data.message);
      setWorkerModal(false);
      setRowId('');
      getList();
    } catch (error) {
      handelerrors(error);
      setSubmitLoading(false);
    }
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  return (
    <Modal
      title={`گروه‌های نقطه سرویس`}
      open={openModal}
      onCancel={close}
      closable={false}
      width={1200}
      footer={[
        <Button key='back' onClick={close}>
          بستن
        </Button>,
      ]}
    >
      <Row>
        <Col span={24}>
          <Table
            size='small'
            style={{ textAlign: 'right', marginTop: 10 }}
            rowClassName={() => 'center'}
            bordered={true}
            pagination={false}
            loading={loading}
            columns={columns}
            dataSource={data}
            locale={{
              emptyText: 'موردی یافت نشد',
            }}
          />
        </Col>
      </Row>

      {workerModal && (
        <Modal
          title={`لیست نیروهای سفارش`}
          open={workerModal}
          onCancel={() => {
            setWorkerModal(false);
            setWorkers([]);
          }}
          closable={false}
          width={1000}
          footer={[
            <Button
              block
              disabled={selectedRowKeys?.length < 1}
              key='submit'
              loading={submitLoading}
              onClick={handleSubmit}
              className='btn btn-primary rounded-0'
            >
              اختصاص نیروهای انتخاب شده به گروه
            </Button>,
          ]}
        >
          <Table
            size='small'
            style={{ textAlign: 'right', marginTop: 10 }}
            rowClassName={(record) => 'center'}
            columns={workerColumns}
            bordered={true}
            dataSource={workers}
            loading={workersLoading}
            rowSelection={{
              selectedRowKeys,
              onChange: onSelectChange,
            }}
            pagination={false}
            locale={{
              emptyText: 'موردی یافت نشد',
            }}
          />
        </Modal>
      )}
    </Modal>
  );
};

export default ServicePointGroups;
